export const getSectionState = (state: Record<string, any>) => (section: string) =>
  state.iterableGoals.goalAnalytics?.[section];
